// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_3vigV-hD0T","heading":"_12CiroJkEP","knotches":"_7WpeABnGHg","subtitle":"_1sg9F9iW8r"};